import React from 'react'
import classes from '@src/styles/ProviderFeatures.module.css'
import classNames from 'classnames'

import confirmJobs from '@src/assets/warrior-features/confirm-jobs.svg'
import fastPayments from '@src/assets/warrior-features/fast-payments.svg'
import allInOne from '@src/assets/warrior-features/all-in-one.png'
import notifications from '@src/assets/warrior-features/notifications.svg'

function ProviderFeatures() {
  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <h2 className={classes.heading}>A modern tool for modern providers</h2>
        <p className={classes.subHeading}>
          Streamline your booking, payment and management systems with our convenient online
          service.
        </p>
        <div className={classes.featureContainer}>
          <div className={classes.feature}>
            <img alt='confirm jobs' src={confirmJobs.src} />
            <h4 className={classNames(classes.heading, classes.cardHeading)}>
              Confirm Tasks Online
            </h4>
            <p className={classes.description}>
              Our nationwide job pool makes it easy to find and secure jobs online. Once you’ve
              taken the booking, it’s removed from the pool ensuring clients never double book for
              the same job.
            </p>
          </div>
          <div className={classes.feature}>
            <img alt='fast payments' src={fastPayments.src} />
            <h4 className={classNames(classes.heading, classes.cardHeading)}>Fast Payments</h4>
            <p className={classes.description}>
              We’ll automatically begin the payment process when you complete the job. Funds will be
              deposited into your linked account via Stripe, ensuring quick and consistent payouts.
            </p>
          </div>
          <div className={classes.feature}>
            <img alt='all in one' src={allInOne.src} />
            <h4 className={classNames(classes.heading, classes.cardHeading)}>All-in-one</h4>
            <p className={classes.description}>
              Reduce admin work by keeping everything on a single platform, including: schedules,
              receipts, compliance data and payments.{' '}
            </p>
          </div>
          <div className={classes.feature}>
            <img alt='notifications' src={notifications.src} />
            <h4 className={classNames(classes.heading, classes.cardHeading)}>
              Instant Notifications
            </h4>
            <p className={classes.description}>
              Get automated texts when new jobs are available and reminders for upcoming jobs.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProviderFeatures
